import {Link} from 'react-router-dom';

function Nav() {
    return (
        <nav class="Nav">
            <Link to="/" class="NavItem">Home</Link>
            <Link to="/tutors-list-page" class="NavItem">Tutors</Link>
            <Link class="NavItem">Join us</Link>
            <Link class="NavItem">About</Link>
            <Link class="NavItem">Contact</Link>
        </nav>
    )
}

export default Nav